import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Tarneaja nägemiseks tee lisavalik

  <span style="color:#85c1dc;">**FI:**</span>
  Nähdäksesi toimitusajan tee lisävalinta

  <span style="color:#85c1dc;">**RU:**</span>
  Сделайте выбор, чтобы увидеть время доставки
*/
/* @__NO_SIDE_EFFECTS__ */
const m929 = msg(
  mf`Tarneaja nägemiseks tee lisavalik`,
  mf`Nähdäksesi toimitusajan tee lisävalinta`,
  mf`Сделайте выбор, чтобы увидеть время доставки`,
)

export { m929 as 'w.module.delivery_section.delivery_time.select_option' }